var map = {
	"./adm.jpg": 237,
	"./alvean.jpg": 238,
	"./bunge.jpg": 239,
	"./cargil.jpg": 240,
	"./chiquita.jpg": 241,
	"./cofco.jpg": 242,
	"./cutrale.jpg": 243,
	"./ecom.jpg": 244,
	"./glencore.jpg": 245,
	"./hkg.jpg": 246,
	"./ldc.jpg": 247,
	"./olam.jpg": 248,
	"./reinhart.jpg": 249,
	"./socotab.jpg": 250,
	"./sucafina.jpg": 251,
	"./volcafe.jpg": 252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 236;